import angular from 'angular';
import doctorAppointmentsCardComponent from './doctor-appointments-card.component';

const doctorAppointmentsCard = angular
	.module('doctorAppointmentsCard', [])
	.component('doctorAppointmentsCard', doctorAppointmentsCardComponent)
	.name;

export default doctorAppointmentsCard;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-appointments-card/doctor-appointments-card.modules.js